import {Clickable} from "../elements/Clickable";
import React from "react";
import SortArrow from "../elements/SortArrow";
import styled from "styled-components";
import {logAction} from "../../logging/logEvent";

const Container = styled(Clickable)`
    font-weight: ${props => props.isActive ? "bold" : "normal"};
`;

const SortArrowContainer = styled.div`
    width: 8px;
    margin-left: 2px;
    margin-top: 2px;
`;

export const RightAlignedSortableCell = styled.div`
    margin-right: 10px;
`;

export const SortableHeading = ({
                                    sortByFieldFn, sortState, fieldName, children,
                                    horizontalAlignment = "flex-start",
                                    tableName,
                                    descendingFirst = true
                                }) => {

    const onClickSortBy = () => {
        logAction({
            type: `SORTABLE_HEADING_CLICKED`,
            fieldName,
            tableName,
            currentDirection: sortState.direction
        });
        sortByFieldFn(fieldName, descendingFirst);
    };

    let sortArrow = null;
    const isActive = sortState.field === fieldName && sortState.direction;
    if (isActive) {
        sortArrow = sortState.direction === "asc" ? <SortArrow dir="ASC"/> : <SortArrow dir="DESC"/>;
    }

    return <Container onClick={onClickSortBy}
                      isActive={isActive}
                      className={`t-${fieldName}-heading`}
                      horizontalAlignment={horizontalAlignment}>
        { children }
        <SortArrowContainer className="t-arrow-container">{sortArrow}</SortArrowContainer>
    </Container>
};